import { Tooltip } from '@workramp/ui';
import { useDateTimeTextFormatter, useRelativeTimeFormatter } from '../../hooks';
import { formatRelativeTime } from '../../utils';

export interface RelativeTimeTextProps {
  showTooltip?: boolean;
  date: number | string | Date;
  className?: string;
}

export function RelativeTimeText({ className, showTooltip = true, date }: RelativeTimeTextProps) {
  const dateFormatter = useDateTimeTextFormatter({
    showTime: true,
    showWeekday: true,
    isLocalTime: true,
  });

  const relativeTimeFormatter = useRelativeTimeFormatter({ numeric: 'auto' });

  const formattedTime = formatRelativeTime(date, relativeTimeFormatter);

  const text = <span className={className}>{formattedTime}</span>;

  if (showTooltip) {
    return <Tooltip message={dateFormatter.format(new Date(date))}>{text}</Tooltip>;
  }

  return text;
}
